import { View } from 'reshaped'
import styles from './ZoraLogo.module.css'

export const ZoraLogo = () => {
  // Fixed heights for reference, matching the SVG viewBox
  const baseHeight = 1048
  const defaultHeight = 524
  const scale = defaultHeight / baseHeight

  return (
    <View width={{ s: '360px', m: '600px' }} height={{ s: 40, m: 72.5 }}>
      <View
        className={styles.container}
        attributes={{ style: { '--z-scale': scale } }}
        width="100%"
        height="100%"
      >
        <View
          className={styles.wordmarkBg}
          attributes={{ style: { width: '100%', height: '100%' } }}
        />
        <svg
          className={styles.wordmarkOutlineShadow}
          width="100%"
          height="100%"
          viewBox="0 0 3076 1048"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2156.87 52.6505L2113.07 189.774C2084.23 140.847 2045.64 104.775 1998.2 82.4799C1954.9 62.1556 1897.7 52.6505 1818.26 52.6505H1461.12V78.034C1411.6 53.9208 1356.47 41.4152 1297.12 41.4152C1247.8 41.4152 1202.07 49.1901 1160.43 64.5428V52.6286H524.118V0H204.032V76.3038C171.005 92.5107 141.569 114.412 116.339 141.569C63.2726 198.71 36.3998 269.056 36.3998 350.529C36.3998 415.707 52.8038 474.183 85.13 524.818L0 533.907L20.1272 666.169C33.1365 751.518 65.8131 820.923 117.171 872.303C142.467 897.599 171.618 918.23 203.988 933.78V1047.34H524.074V966.128H1171.87V957.871C1210.59 970.705 1252.6 977.297 1297.27 977.297C1357.11 977.297 1412.15 965.274 1460.94 942.102V966.084H1825.27V888.948L1867.8 966.128L2251.22 966.084L2295.82 817.2H2322.69L2369.88 966.084H2758.32L2458.3 52.6505H2156.85H2156.87ZM2395.09 931.217L2347.9 782.333H2270.12L2225.53 931.217L1888.12 931.261L1790.8 754.606V931.217H1495.37V881.107C1440.33 921.384 1373.1 942.431 1297.25 942.431C1238.18 942.431 1184.33 929.925 1137.37 905.658V931.239H512.225V897.971C504.888 901.563 497.398 904.958 489.623 908.024V1012.47H238.46V910.827C201.601 896.307 169.165 875.084 141.547 847.489C95.4235 801.365 66.0321 738.465 54.1836 660.496L39.466 563.868L151.206 551.845C144.351 545.055 137.956 537.981 131.999 530.578C91.3937 480.162 70.8066 422.496 70.8066 349.981C70.8066 277.466 94.6351 215.07 141.591 164.478C168.814 135.13 201.294 112.944 238.504 98.1831V33.9688H489.667V98.8839C509.312 106.725 527.49 116.514 544.113 128.232V86.6412H1125.9V118.157C1175.07 89.8606 1232.56 75.4496 1297.03 75.4496C1371.74 75.4496 1439.04 97.1537 1495.48 138.7V86.6631H1818.17C1892.39 86.6631 1944.91 95.095 1983.5 113.207C2026.8 133.575 2061.8 167.5 2087.49 214.062C2100.74 237.935 2110.38 264.172 2116.29 292.512L2181.99 86.685H2433.33L2433.18 86.7507L2710.69 931.283H2395.07L2395.09 931.217Z"
            fill="white"
          />
        </svg>
        <View
          className={styles.wordmarkOutline}
          attributes={{ style: { width: '100%', height: '100%' } }}
        />
        <View
          className={styles.wordmarkOutlineHighlight}
          attributes={{ style: { width: '100%', height: '100%' } }}
        />
        <img alt="Zorb" className={styles.wordmarkZorb} src="/assets/zorb.png" />
      </View>
    </View>
  )
}
